import axios from '../../../axios';
import { IEmailAnalyticsFilter, ISubmissionAnalyticsPayload } from '../../AnalyticsService';

const url = 'wsreporting/api/email-analytics/';

export const getTotalEmailsSentByUsers = (filterDTO: IEmailAnalyticsFilter) =>
  axios.post(`${url}total-emails-sent`, filterDTO);

export const getEmailsSentByUsers = (filterDTO: IEmailAnalyticsFilter) =>
  axios.post(`${url}emails-sent-by-users`, filterDTO);

export const getEmailsInPostgre = (
  searchQuery: ISubmissionAnalyticsPayload,
  abortController: AbortController
) =>
  axios.post(
    `/analyticsreportingapp/api/email-logs/composable-analytics?type=${searchQuery.type}`,
    searchQuery,
    abortController
  );
